import { schema } from "normalizr";
import { LinesheetLink as Record } from "records/page";
import { MediaSchema } from "schemas/media";

export const LinesheetLinkSchema = new schema.Entity("linesheetLinks", {
    media: MediaSchema,
});

(LinesheetLinkSchema as any).record = Record;
